import config from '../config/environment';

interface CheckPaymentPaidResponse {
  paid?: boolean;
  status?: string | null;
  found?: boolean;
}

interface PaymentGatewayResponse {
  data?: CheckPaymentPaidResponse;
  error?: string;
}

export class CheckoutPaymentStatusService {
  static async isPaymentPaid(externalPaymentId: string): Promise<boolean> {
    const normalizedPaymentId = externalPaymentId.trim();

    if (!normalizedPaymentId) {
      return false;
    }

    const response = await fetch(`${config.supabaseFunctionsUrl}/payment-gateway`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: config.supabaseAnonKey,
        Authorization: `Bearer ${config.supabaseAnonKey}`,
      },
      body: JSON.stringify({
        action: 'check-payment-paid',
        provider: 'asaas',
        external_payment_id: normalizedPaymentId,
      }),
    });

    const body = await response.json().catch(() => ({})) as PaymentGatewayResponse;

    if (!response.ok) {
      throw new Error(body.error || 'Não foi possível verificar o status do pagamento.');
    }

    return Boolean(body.data?.paid);
  }
}
